export const PROFILE_SIDE_PANEL_REQUEST_PREFIX = 'profile-side-panel'
export const PROFILE_SIDE_PANEL_ORGANIZATION_DETAIL_REQUEST_KEY = 'profile-side-panel-organization-detail'
export const PROFILE_SIDE_PANEL_ADMIN_DETAIL_REQUEST_KEY = 'profile-side-panel-admin-detail'
export const PROFILE_SIDE_PANEL_ADMIN_UPDATE_REQUEST_KEY = 'profile-side-panel-admin-update'
export const PROFILE_SIDE_PANEL_PERSONA_DETAIL_REQUEST_KEY = 'profile-side-panel-persona-detail'
export const PROFILE_SIDE_PANEL_PERSONA_UPDATE_REQUEST_KEY = 'profile-side-panel-persona-update'
export const PROFILE_SIDE_PANEL_VERIFIED_INFO_DETAIL_REQUEST_KEY = 'profile-side-panel-verified-info-detail'
